import { render, staticRenderFns } from "./store-info.vue?vue&type=template&id=d5221f10&scoped=true&"
import script from "./store-info.vue?vue&type=script&lang=js&"
export * from "./store-info.vue?vue&type=script&lang=js&"
import style0 from "./store-info.vue?vue&type=style&index=0&id=d5221f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5221f10",
  null
  
)

export default component.exports